import { ChatControl } from "./classes/ChatControl";
window.addEventListener("load", (event) => {
    let initSession = Date.now();
    sessionStorage.setItem("init_session", initSession.toString());
    sessionStorage.setItem("realSessionId", Math.random().toString().slice(2, 12).toString());
    new ChatControl();
});
